import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=2145c708&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=2145c708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2145c708",
  null
  
)

export default component.exports